
import { Expose, Type } from "class-transformer";
import { IFilter } from "../types";

export class FarmAnalysisResult {
  public uuid!: string;
  
  @Expose({ name: "pipeline_version" })
  public pipelineVersion!: string;

  @Expose({ name: "crop_type" })
  public cropType!: string;

  @Type(() => Date)
  @Expose({ name: "average_planting_date" })
  public averagePlantingDate!: Date;

  @Type(() => Date)
  @Expose({ name: "average_harvest_date"})
  public averageHarvestDate!: Date;

  @Expose({ name: "average_yield" })
  public averageYield!: number;

  @Expose({ name: "crop_area"})
  public cropArea!: number;

  @Expose({ name: "production" })
  public production!: number;

  @Expose({ name: "harvest_season" })
  public harvestSeason!: string;

  @Expose({ name: "yield_score" })
  public yieldScore!: string;

  @Expose({ name: "yield_score_micro_region" })
  public yieldScoreMicroRegion!: string;

  @Expose({ name: "yield_score_state" })
  public yieldScoreState!: string;

  @Expose({ name: "yield_score_country" })
  public yieldScoreCountry!: string;

  @Expose({ name: "yield_score_year" })
  public yieldScoreYear!: number;

  @Expose({ name: "s3_geojson_url" })
  public s3GeoJsonUrl!: string;

  @Expose({ name: "arable_area" })
  public arableArea: number = 0.0;

  @Expose({ name: "yield_std" })
  public yieldStd: number = 0.0;

  @Expose({ name: "score_std" })
  public scoreStd: number = 0.0;

  @Expose({ name: "actual_yieldest_source"})
  public actualYieldestSource: string = "";

  @Expose({ name: "actual_cropid_source"})
  public actualCropIdSource: string = "";
  
  @Expose({ name: "crop_id_version"})
  public cropIdVersion: string = "";

  @Expose({ name: "yieldest_version"})
  public yieldestVersion: string = "";
  
  public visible: boolean = true;

  
  get safeCropIdVersion() {
    return this.cropIdVersion == null ? '' : this.cropIdVersion;
  }

  get safeYieldestVersion() {
    return this.yieldestVersion == null ? '' : this.yieldestVersion;
  }

  get safeActualYieldestSource() {
    return this.actualYieldestSource == null ? '' : this.actualYieldestSource;
  }

  get safeActualCropIdSource() {
    return this.actualCropIdSource == null ? '' : this.actualCropIdSource;
  }

}

export class ScoreHistogramDTO {
  public admitted!: boolean;

  @Type(() => HistogramScoresDTO)
  @Expose({ name: "histogram_scores" })
  public histogramScores!: HistogramScoresDTO[];

}

export class HistogramScoresDTO {
  public count!: number;

  @Expose({ name: "score_range" })
  public scoreRange!: number;

}

function emptyListHistogramScoresDTO() {
  return [10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(scoreRange => {
    const histogramScore = new HistogramScoresDTO();
    histogramScore.count = 0;
    histogramScore.scoreRange = scoreRange;
    return histogramScore;
  });
}

export function emptyScoreHistogramDTO(admitted: boolean) {
  const scoreHistogram = new ScoreHistogramDTO();
  scoreHistogram.admitted = admitted;
  scoreHistogram.histogramScores = emptyListHistogramScoresDTO();
  return scoreHistogram;
}

export class AreaHistogramDTO {
  public admitted!: boolean;

  @Type(() => HistogramAreasDTO)
  @Expose({ name: "histogram_areas" })
  public histogramAreas!: HistogramAreasDTO[];

}

export class HistogramAreasDTO {
  public count!: number;

  @Expose({ name: "area_range" })
  public areaRange!: number;
}

function emptyListHistogramAreasDTO() {
  return [50, 100, 500, 1000, 5000, 10000, 100000].map(areaRange => {
    const histogramArea = new HistogramAreasDTO();
    histogramArea.count = 0;
    histogramArea.areaRange = areaRange;
    return histogramArea;
  });
}

export function emptyAreaHistogramDTO(admitted: boolean) {
  const areaHistogram = new AreaHistogramDTO();
  areaHistogram.admitted = admitted;
  areaHistogram.histogramAreas = emptyListHistogramAreasDTO();
  return areaHistogram;
}

export class AreaAndScoreHistogramFilter implements IFilter {
  constructor(
    public cropType: string = 'SOY',
    public onlyUserOwners: boolean = false,
    public harvestSeason: string = 'SUMMER',
    public analysisYear?: number,
  ) {}
}


export class HarvestResultTableDTO {
      
  @Expose({ name: "analysis_year" })
  public analysisYear!: number;
  
  @Expose({ name: "crop_type" })
  public cropType!: string;
  
  @Type(() => Date)
  @Expose({ name: "average_planting_date" })
  public averagePlantingDate!: Date;
  
  @Type(() => Date)
  @Expose({ name: "average_harvest_date" })
  public averageHarvestDate!: Date;
  
  @Expose({ name: "harvest_season" })
  public harvestSeason!: string;
  
  @Expose({ name: "average_yield" })
  public averageYield!: number;

  @Expose({ name: "crop_area"})
  public cropArea!: number;

  get production() {
    return parseInt(this.averageYield * this.cropArea + '', 10);
  }
}
